import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationSummary = ({ registrationData }) => {

  if (!registrationData) {
    return <></>;
  }

  const {
    profile,
    paymentAmount,
    registrationDate,
    batchInfo,
    paymentMethod,
    transactionId
  } = registrationData;


  const summaryItems = [
    {
      label: 'Selected Profile',
      value: profile,
      icon: 'User',
      color: 'text-primary'
    },
    // {
    //   label: 'Program Fee',
    //   value: `₹${paymentAmount.toLocaleString('en-IN')}`,
    //   icon: 'CreditCard',
    //   color: 'text-success'
    // },
    {
      label: 'Registration Date',
      value: registrationDate,
      icon: 'Calendar',
      color: 'text-accent'
    },
    {
      label: 'Assigned Batch',
      value: batchInfo,
      icon: 'Users',
      color: 'text-secondary'
    },
    {
      label: 'Payment Method',
      value: paymentMethod,
      icon: 'Wallet',
      color: 'text-foreground'
    },
    // {
    //   label: 'Transaction ID',
    //   value: transactionId,
    //   icon: 'Hash',
    //   color: 'text-text-secondary'
    // }
  ];

  return (
    <div className="bg-surface border border-border rounded-xl p-6 mb-8">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="FileText" size={20} color="var(--color-primary)" strokeWidth={2} />
        <h2 className="text-xl font-semibold text-foreground">
          Registration Summary
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {summaryItems.map((item, index) => (
          <div
            key={index}
            className="flex items-start space-x-3 p-4 bg-muted/50 rounded-lg hover:bg-muted transition-smooth"
          >
            <div className={`flex-shrink-0 mt-0.5 ${item.color}`}>
              <Icon name={item.icon} size={18} strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-text-secondary mb-1">
                {item.label}
              </p>
              <p className="text-sm font-semibold text-foreground break-words">
                {item.value}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Payment Status Badge */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-center space-x-2 p-3 bg-success/10 border border-success/20 rounded-lg">
          <Icon name="CheckCircle" size={18} color="var(--color-success)" strokeWidth={2} />
          <span className="text-sm font-semibold text-success">
            Payment Confirmed & Processed
          </span>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSummary;